import { MButton, MoreButton } from '@Components/Base';
import { ReactComponent as SaveCardIcon } from '@Icons/additional/save-card.svg';
import { ReactComponent as UnlockIcon } from '@Icons/additional/opened-lock.svg';
import { Flex } from 'antd';

interface MaterialsFooterProps {
  onReviewApprove: () => void;
  onSaveAsDraft: () => void;
  onUnlockPricing: () => void;
  totalAmount: number;
}

const MaterialsFooter: React.FC<MaterialsFooterProps> = ({
  onReviewApprove,
  onUnlockPricing,
  onSaveAsDraft,
  totalAmount,
}) => {
  const actions = [
    {
      key: '0',
      label: (
        <Flex className="trojan-more-action-item" onClick={onSaveAsDraft}>
          <SaveCardIcon />
          <span>Save As Draft</span>
        </Flex>
      ),
    },
    {
      key: '1',
      label: (
        <Flex className="trojan-more-action-item" onClick={onUnlockPricing}>
          <UnlockIcon />
          <span>Unlock Pricing</span>
        </Flex>
      ),
    },
  ];

  return (
    <Flex gap={8} justify="space-between">
      <MButton
        type="primary"
        style={{ width: '100%' }}
        onClick={onReviewApprove}
      >
        <Flex gap={8} justify="space-between">
          <span>Review & Approve</span>
          <span>{totalAmount} AED</span>
        </Flex>
      </MButton>
      <MoreButton title="Choose Actions" actionItems={actions} />
    </Flex>
  );
};

export default MaterialsFooter;
